import * as R from 'ramda';
import { combineActions, handleActions } from 'redux-actions';

import { listToItems } from '../../utils';
import * as commonReducers from './common';
import * as actions from '../actions/users';
import { cancelUserInvitation } from '../actions/invitations';

const { fetch } = commonReducers.operationTypes;

const fetchUsersSuccessReducer = (state, { payload }) => ({
  ...state,
  [fetch]: false,
  isInviteUser: false,
  items: { ...state.items, ...listToItems(payload.users) },
});

const manageUser = (state, { payload }) => ({
  ...state,
  items: { ...state.items, [payload._id]: { ...payload } },
});

const cancelUserInvitationReducer = (state, { payload }) => ({
  ...state,
  items: R.dissoc(payload.id, state.items),
});


export const usersReducers = handleActions(
  {
    // fetch
    [actions.fetchUsersRequest]: commonReducers.commonRequestReducer(fetch),
    [actions.fetchUsersFailure]: commonReducers.commonFailureReducer(fetch),
    [actions.fetchUsersSuccess]: fetchUsersSuccessReducer,

    [combineActions(
      actions.deleteUser,
      actions.restoreUser,
      actions.changeUserRole,
    )]: manageUser,

    [cancelUserInvitation]: cancelUserInvitationReducer,
  },
  {
    items: {},
    [fetch]: false,
  },
);



// WEBPACK FOOTER //
// ./src/redux/reducers/users.js